export default __webpack_public_path__ + "static/media/AdobeStock_297359062.5c2a0410.jpeg";